import { fetchPost, fetchGet, fetchPut, fetchDelete, patchRequest } from '.';
import { constructQueryString } from '../utils/constructQueryString';

export const fetchLocations = async (options = {}) => {
  const queryString = constructQueryString(options);
  return await fetchGet(`/location${queryString}`);
};
